import { render, staticRenderFns } from "./learner-identity.vue?vue&type=template&id=65cc607e&scoped=true&"
import script from "./learner-identity.ts?vue&type=script&lang=ts&"
export * from "./learner-identity.ts?vue&type=script&lang=ts&"
import style0 from "./learner-identity.scss?vue&type=style&index=0&id=65cc607e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cc607e",
  null
  
)

export default component.exports